// extracted by mini-css-extract-plugin
export default {"popoverContent":"policies_breakdown_popoverContent__k5Ye9","popover":"policies_breakdown_popover__lZMTx"};